import {
  BrowserMessageReceiveType,
  BrowserMessageType,
  registerElectronMessageReceiver,
  sendElectronMessage,
} from 'electron-communication-lib/BrowserForApp';
import {useMountEffect} from 'webapp-lib/utils';

import {DocumentUploadStore} from '_/store/DocumentUpload.store';

import {
  PendingUploadTriggers,
  showPendingUploadsConfirmationDialog,
} from './showPendingUploadsConfirmationDialog';

export const useHandleCloseRequested = (
  documentUploadStore: DocumentUploadStore
): void => {
  const handleCloseRequested = () => {
    showPendingUploadsConfirmationDialog({
      trigger: PendingUploadTriggers.CLOSE,
      numberOfPendingFiles: documentUploadStore.pendingFiles.length,
      numberOfFailedFiles: documentUploadStore.failedFiles.length,
      proceed: () => {
        sendElectronMessage({
          type: BrowserMessageType.SAFE_EXIT_APPLICATION_WITHOUT_WEB_CHECK,
          payload: null,
        });
      },
    });
  };

  useMountEffect(() => {
    registerElectronMessageReceiver(
      BrowserMessageReceiveType.CLOSE_REQUESTED,
      handleCloseRequested
    );
  });
};
